import type { FrameTransactionStatus } from "@moonpay/platform-protocol/models/transaction";
import type { LegacyWidgetMessage, RampsMessage, WidgetMessage } from "./widget-message.types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function isRampsMessage(data: unknown): data is RampsMessage {
  if (!isRecord(data)) {
    return false;
  }
  return (
    data.version === 1 &&
    data.appName === "ramps" &&
    data.type === "request" &&
    typeof data.action === "string"
  );
}

function isLegacyWidgetMessage(data: unknown): data is LegacyWidgetMessage {
  return isRecord(data) && typeof data.type === "string" && data.type.startsWith("MOONPAY_");
}

export function parseWidgetMessage(data: unknown): WidgetMessage | null {
  const parsed = typeof data === "string" ? (JSON.parse(data) as unknown) : data;
  if (isRampsMessage(parsed) || isLegacyWidgetMessage(parsed)) {
    return parsed;
  }
  return null;
}

export function safelyParseWidgetMessage(data: unknown): WidgetMessage | Error | null {
  try {
    return parseWidgetMessage(data);
  } catch (error) {
    return error instanceof Error ? error : new Error("Failed to parse message from widget");
  }
}

export function mapTransactionStatus(status: string): FrameTransactionStatus {
  if (status === "completed" || status === "failed") {
    return status;
  }
  return "pending";
}
